import { render, staticRenderFns } from "./ReplayCreateForm.vue?vue&type=template&id=c70509f4"
import script from "./ReplayCreateForm.vue?vue&type=script&lang=js"
export * from "./ReplayCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports